import {Config} from "../Config";
import * as util from 'util';
import * as _ from 'lodash';

import * as Debug from 'debug';
let debug:Debug.IDebugger = Debug.debug('vgift.com:libs:HttpRequestHelper');

/**
 * Class to help deal with HTTP requests
 */
export class HttpRequestHelper {

    private static _baseUrl:string;

    /**
     * Get the base URL for api
     */
    public static getAPI1BaseUrl():string
    {
        // build base url if we don't have it
        if (_.isUndefined(HttpRequestHelper._baseUrl) == true)
        {
            // using config environment for http requests
            HttpRequestHelper._baseUrl = util.format('%s://%s:%s', Config.APIInternaTransport, Config.APIInternalBaseDomain, Config.APIInternalPort);
        }

        return HttpRequestHelper._baseUrl;
    }

    /**
     * Build http request options using the http method GET.
     *
     * @param url
     */
    public static buildGetHttpRequestOptions(url: string): any {
        debug('HttpRequestHelper.buildGetHttpRequestOptions: url is');
        debug(url);

        let requestOptions:any = {
            url: url,
            method: 'get',
            // cors requests attempted
            withCredentials: true,
        };

        return requestOptions;
    }

    /**
     * Build http request options using the http method DELETE.
     *
     * @param url
     */
    public static buildDeleteHttpRequestOptions(url: string): any {
        debug('HttpRequestHelper.buildGetHttpRequestOptions: url is');
        debug(url);

        let requestOptions:any = {
            url: url,
            method: 'delete',
            // cors requests attempted
            withCredentials: true,
        };

        return requestOptions;
    }

    /**
     * Build http request options as http method POST with form data.
     *
     * @param url
     * @param formData
     */
    public static buildPostHttpRequestOptionsForm(url: string, formData: FormData): any {
        debug('HttpRequestHelper.buildPostHttpRequestOptionsForm: url and params are:');
        debug(url);

        // setup request
        let requestOptions:any = {
            url: url,
            method: 'post',
            data: formData,
            headers: { 'Content-Type': 'multipart/form-data' },
            // cors requests attempted
            withCredentials: true,
        };

        return requestOptions;
    }

    /**
     * Build http request options as http method POST with JSON parameters.
     *
     * @param url
     * @param params
     */
    public static buildPostHttpRequestOptionsJSON(url: string, params: any): any {
        debug('HttpRequestHelper.buildPostHttpRequestOptionsJSON: url and params are:');
        debug(url);
        debug(params);

        // build post data
        let postData:any = HttpRequestHelper.buildPostPutData(params);
        debug(postData);
        // setup request
        let requestOptions:any = {
            url: url,
            method: 'post',
            data: postData,
            headers: { 'Content-Type': 'application/json' },
            // cors requests attempted
            withCredentials: true,
        };

        return requestOptions;
    }

    /**
     * Build http request options as http method PUT with JSON parameters.
     *
     * @param url
     * @param params
     */
    public static buildPutHttpRequestOptionsJSON(url: string, params: any): any {
        debug('HttpRequestHelper.buildPutHttpRequestOptionsJSON: url and params are:');
        debug(url);
        debug(params);

        // build post data
        let putData:any = HttpRequestHelper.buildPostPutData(params);
        debug(putData);
        // setup request
        let requestOptions:any = {
            url: url,
            method: 'put',
            data: putData,
            headers: { 'Content-Type': 'application/json' },
            // cors requests attempted
            withCredentials: true,
        };

        return requestOptions;
    }

    /**
     * Build post/put data given object property/value pairs which will be
     *
     * @param params
     * @returns {string} - build post/put data as JSON string representation of object.
     */
    public static buildPostPutData(params: any): string {
        let paramsNames:string[]|null = null;
        let paramsCount:number = 0;
        let finalParamsObject:{[key:string]:any} = {};
        let finalParamsObjectAsString: string = '{}'; // empty list of parameters

        //
        let finalParams: any = {}; // final params will have these two fields
        if (params != null && Object.keys(params).length > 0) {
            // clone object expecting it is only one level deep
            finalParams = (<any>Object).assign({}, params);
        }

        // Assuming nothing went wrong, final params should always be set
        if (finalParams != null) {
            // get parameter names
            paramsNames = Object.keys(finalParams);

            for (let i:number = 0; i < paramsNames.length; i++) {
                // name of name value pair
                let name:string = paramsNames[i];
                let value:string|number = finalParams[name];

                // add name/value to resultant object
                finalParamsObject[name] = value;

                paramsCount++;
            }

            // convert object to string
            finalParamsObjectAsString = JSON.stringify(finalParamsObject);
        }

        return finalParamsObjectAsString;
    }

    /**
     * Output HTTP request to console
     *
     * @param method
     * @param url
     * @param params
     */
    public static outputDebugHttpRequest(method:EHttpRequestMethod, url: string, params?: any): void {

        // if params given
        if (_.isUndefined(params) == false)
        {
            // output to debug console
            //tslint:disable-next-line
            console.debug(util.format("%s: %s, payload:", method.toString(), url));
            //tslint:disable-next-line
            console.debug(params);
        }
        else
        {
            // otherwise just output method and url to debug console
            //tslint:disable-next-line
            console.debug(util.format("%s: %s", method.toString(), url));
        }

    }

}

/**
 * What is the request method?
 */
export enum EHttpRequestMethod {
    Post = 'post',
    Put = 'put',
    Get = 'get',
    Delete = 'delete'
}
